import { createSelector } from "reselect";
import { Reducer } from "redux";
import { ChatSuggestionActions } from "../actions/chat-suggestion-actions";
import { AppRootState } from "./root-reducer";
import { ChatbotSuggestion, ChatSuggestionState, initialChatSuggestionState } from "../types/chat-suggestion-types";

export const chatSuggestionReducer: Reducer = (state = initialChatSuggestionState, action) => {

    switch (action.type) {
        case ChatSuggestionActions.SHOW_SUGGESTION:
            return {
                ...state,
                chatbotSuggestion: action.meta,
                filterSuggestion: action.meta,
                showSuggestion: state.filterSuggestion.length > 0 ? action.payload : false
            }
        case ChatSuggestionActions.SUGGESTION_INPUT:
            return {
                ...state,
                suggestionInput: action.payload
            }
        case ChatSuggestionActions.FILTER_SUGGESTION_LIST:
            let map = new Map();
            state.chatbotSuggestion.filter((item: ChatbotSuggestion) => {
                if (item.prompts != null && item.prompts.toLocaleLowerCase().indexOf(action.meta.toLocaleLowerCase()) != -1) {
                    map.set(item.intentCode, item);
                    return item;
                }
            });

            return {
                ...state,
                filterSuggestion: Array.from(map.values()),
                showSuggestion: state.filterSuggestion.length > 0 ? action.payload : false,
                collapse: true
            }
        case ChatSuggestionActions.UPDATE_SHOW_SUGGESTION:
            return {
                ...state,
                showSuggestion: (state.filterSuggestion && state.filterSuggestion.length > 0) ? action.payload : false,
            }
        case ChatSuggestionActions.CLEAN_SUGGESTION:
            return {
                ...state,
                filterSuggestion: [],
                chatbotSuggestion: [],
                showSuggestion: false
            }
        case ChatSuggestionActions.SET_INPUT_ACTION:
            return {
                ...state,
                inputValue: action.payload
            }
        case ChatSuggestionActions.CLEAR_INPUT:
            return {
                ...state,
                clearInput: action.payload
            }
        case ChatSuggestionActions.SET_SHOW_SUGGESTION_FLAG:
            console.log("*****showSuggestinFlag******", action.payload)
            return {
                ...state,
                showSuggestinFlag: action.payload
            }
        default:
            return state
    }
}

const showSuggestion = (state: AppRootState) => state.chatSuggestionReducer.showSuggestion;
export const getShowSuggestion = createSelector([showSuggestion], (data) => data);

const showSuggestinFlag = (state: AppRootState) => state.chatSuggestionReducer.showSuggestinFlag;
export const getShowSuggestinFlag = createSelector([showSuggestinFlag], (data) => data);

const chatbotSuggestion = (state: AppRootState) => state.chatSuggestionReducer.chatbotSuggestion;
export const getChatbotSuggestionList = createSelector([chatbotSuggestion], (data) => data);

const filterSuggestion = (state: AppRootState) => state.chatSuggestionReducer.filterSuggestion;
export const getFilterChatbotSuggestionList = createSelector([filterSuggestion], (data) => data);

const chatInputValue = (state: AppRootState) => state.chatSuggestionReducer.inputValue;
export const getChatInputValue = createSelector([chatInputValue], (data) => data);

const clearInput = (state: AppRootState) => state.chatSuggestionReducer.clearInput;
export const getClearInput = createSelector([clearInput], (data) => data);

const suggestionInput = (state: AppRootState) => state.chatMsg.suggestionInput;
export const getSuggestionInput = createSelector([suggestionInput], (data) => data);
